module.exports = __webpack_public_path__ + "static/headerSakes-c3e02fb0bb14d951a286375ac01c5abc.jpg";